var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"twoYAxisBar"},[_c('PublicEcharts',{attrs:{"id":_vm.id,"chartsData":{ listData: _vm.listData },"options":_vm.dealData(),"usePropsOptions":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }